
const api = "http://localhost:8000"
// const api ="https://bcsoro.haisoa.com"

export {api}
